/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Premium_Content_VaultInputs */

const en_premium_content_vault = /** @type {(inputs: Premium_Content_VaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium Content Vault`)
};

const es_premium_content_vault = /** @type {(inputs: Premium_Content_VaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bóveda de contenido premium`)
};

const fr_premium_content_vault = /** @type {(inputs: Premium_Content_VaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coffre-fort de Contenu Premium`)
};

const de_premium_content_vault = /** @type {(inputs: Premium_Content_VaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium-Content-Vault`)
};

const ja_premium_content_vault = /** @type {(inputs: Premium_Content_VaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プレミアムコンテンツ保管庫`)
};

const zh_premium_content_vault = /** @type {(inputs: Premium_Content_VaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`高级内容金库`)
};

const ar_premium_content_vault = /** @type {(inputs: Premium_Content_VaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`خزنة المحتوى المميز`)
};

const id_premium_content_vault = /** @type {(inputs: Premium_Content_VaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vault Konten Premium`)
};

const it_premium_content_vault = /** @type {(inputs: Premium_Content_VaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vault Contenuti Premium`)
};

const ru_premium_content_vault = /** @type {(inputs: Premium_Content_VaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Хранилище премиум-контента`)
};

const pt_premium_content_vault = /** @type {(inputs: Premium_Content_VaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cofre de Conteúdo Premium`)
};

const ko_premium_content_vault = /** @type {(inputs: Premium_Content_VaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`프리미엄 콘텐츠 보관소(Vault)`)
};

/**
* | output |
* | --- |
* | "Premium Content Vault" |
*
* @param {Premium_Content_VaultInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const premium_content_vault = /** @type {((inputs?: Premium_Content_VaultInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Premium_Content_VaultInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_premium_content_vault(inputs)
	if (locale === "es") return es_premium_content_vault(inputs)
	if (locale === "fr") return fr_premium_content_vault(inputs)
	if (locale === "de") return de_premium_content_vault(inputs)
	if (locale === "ja") return ja_premium_content_vault(inputs)
	if (locale === "zh") return zh_premium_content_vault(inputs)
	if (locale === "ar") return ar_premium_content_vault(inputs)
	if (locale === "id") return id_premium_content_vault(inputs)
	if (locale === "it") return it_premium_content_vault(inputs)
	if (locale === "ru") return ru_premium_content_vault(inputs)
	if (locale === "pt") return pt_premium_content_vault(inputs)
	return ko_premium_content_vault(inputs)
});